// Static content for Aurora Springs RedM RP

export const LINKS = {
  connect: "https://cfx.re/join/4dxkmv",
  discord: "https://discord.gg/aurorasprings",
  joinCode: "4dxkmv",
  techSupport: "https://discord.com/channels/1244437675482677298/1393668956828471417",
  rageTicket: "https://discord.com/channels/1244437675482677298/1251667553793867906",
};

export const LOGO = "https://customer-assets-wrfwihn1.emergentagent.net/job_springs-roleplay/artifacts/7e49bft6_LOGO_for_as.png";

// Section image keys the admin panel can override, with their default images.
export const IMAGE_SECTIONS = [
  { key: "hero", label: "Home — Hero background" },
  { key: "manifesto", label: "Home — Manifesto image" },
  { key: "features", label: "Home — Features background" },
  { key: "cta", label: "Home — Call to action background" },
  { key: "guide", label: "Player Guide — Header" },
  { key: "lore", label: "Lore — Header" },
  { key: "rules", label: "Rules — Header" },
  { key: "support", label: "Tech Support — Header" },
  { key: "penal", label: "Penal Code — Header" },
  { key: "jobs", label: "Jobs — Header" },
  { key: "businesses", label: "Businesses — Header" },
  { key: "businessesMap", label: "Businesses — Map backdrop" },
  { key: "gallery", label: "Gallery — Header" },
  { key: "staff", label: "Staff — Header" },
  { key: "streamers", label: "Streamers — Header" },
  { key: "tribes", label: "Native Tribes — Header" },
  { key: "gangs", label: "Gangs — Header" },
  { key: "upload", label: "Upload — Header" },
];

export const IMAGES = {
  hero: "/assets/hero-moonlit.webp",
  heroAlt: "https://images.unsplash.com/photo-1723750600453-3606c844636b?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  manifesto: "https://images.unsplash.com/photo-1723750601188-870ec7510d58?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  aurora: "https://images.unsplash.com/photo-1776854634319-e853ea3aa6af?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  town: "https://images.unsplash.com/photo-1764352104010-aa918868c55c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  townCattle: "https://images.unsplash.com/photo-1764352104028-5cbefb62a9e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  townRide: "https://images.unsplash.com/photo-1764352104264-eb0f91f9facf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  ridge: "https://images.unsplash.com/photo-1613845919393-d9df294adc3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  duskRider: "https://images.unsplash.com/photo-1723750600312-f213ab037d9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  goldRider: "https://images.unsplash.com/photo-1723750599819-0299da32b071?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  countyMap: "https://customer-assets-wrfwihn1.emergentagent.net/job_springs-roleplay/artifacts/jo5wsz0r_large-detailed-map-of-red-dead-redemption-2-world.webp",
};

export const FACES = [
  "https://images.unsplash.com/photo-1584772988869-dccc362700a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1724710152067-f5cda1ed9820?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1663124290528-791668655956?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  "https://images.unsplash.com/photo-1723750601188-870ec7510d58?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
];

// Default image for each admin-managed section key
export const SECTION_DEFAULTS = {
  hero: IMAGES.hero,
  manifesto: IMAGES.manifesto,
  features: IMAGES.aurora,
  cta: IMAGES.duskRider,
  guide: IMAGES.manifesto,
  lore: "https://customer-assets-wrfwihn1.emergentagent.net/job_springs-roleplay/artifacts/dxoeq8a9_avo2.webp",
  rules: IMAGES.ridge,
  penal: IMAGES.townCattle,
  jobs: IMAGES.town,
  businesses: IMAGES.townRide,
  businessesMap: IMAGES.countyMap,
  gallery: IMAGES.goldRider,
  staff: IMAGES.goldRider,
  streamers: IMAGES.duskRider,
  tribes: IMAGES.ridge,
  gangs: IMAGES.duskRider,
  upload: IMAGES.aurora,
};

export const MARQUEE = [
  "Serious Roleplay", "No Pay to Win", "Custom Businesses", "Seasonal Content",
  "Community Events", "Greenhorn Program", "Controller Friendly", "Aurora Springs",
];

export const FEATURES = [
  { n: "01", title: "No Pay to Win", body: "Your story is earned, never bought. No advantages for cash — the frontier rewards effort and roleplay alone." },
  { n: "02", title: "Custom Natives", body: "Deeply custom-developed systems and natives built for Aurora Springs — features you won't find anywhere else." },
  { n: "03", title: "Custom Businesses", body: "Player-owned, bespoke businesses that shape the town's economy and give every citizen a stake in the world." },
  { n: "04", title: "Seasonal Content", body: "A living world that changes with the seasons — fresh events, weather and stories rolling in all year round." },
  { n: "05", title: "Community Events", body: "Regular staff-run events, competitions and story arcs that bring the whole frontier together." },
  { n: "06", title: "Greenhorn Program", body: "Newbie-friendly by design. Our Greenhorn Program guides fresh faces from stagecoach to legend." },
  { n: "07", title: "Controller Friendly", body: "Built to play your way — as controller-friendly as possible so you can ride comfortably on any setup." },
  { n: "08", title: "Visa Program", body: "Try before you're whitelisted. Our Visa Program lets you ride into town and experience Aurora Springs first." },
];

export const MANIFESTO = [
  { n: "01", head: "The frontier remembers", body: "Aurora Springs is not a map — it is a memory in the making. Every choice you carve into the dust stays. Rivalries, romances, fortunes and funerals: the town keeps its ledger." },
  { n: "02", head: "Live a second life", body: "Step off the stagecoach and become someone new. A gunsmith with a secret. A rancher chasing rain. A lawman who bends. Your story starts the moment you connect." },
  { n: "03", head: "Under the same sky", body: "When night falls the aurora burns green and violet over the ridge. We built this world so that strangers become legends beneath it. Ride with us." },
];

export const RULES = [
  { cat: "Core Conduct", items: [
    "Treat every player with respect out-of-character at all times.",
    "No racism, hate speech, or real-world discrimination — instant permanent ban.",
    "Stay in character (IC) while connected to the world.",
    "No metagaming — do not use out-of-character info in-character.",
  ]},
  { cat: "Roleplay Standards", items: [
    "No powergaming — do not force outcomes on other players.",
    "Value your life (NVL/NLR): fear death and act accordingly.",
    "New Life Rule: after downing, you forget the events leading to your death.",
    "Fear RP is mandatory when a weapon is drawn on you.",
  ]},
  { cat: "Combat & Crime", items: [
    "No random death match (RDM) — you must have a valid IC reason.",
    "No vehicle/horse death match (VDM).",
    "Robberies require initiation and a minimum of 2 players present.",
    "Cop-baiting and cceaseless crime sprees are prohibited.",
  ]},
  { cat: "Technical & Meta", items: [
    "No exploiting bugs, glitches, or third-party mods for advantage.",
    "Stream sniping and cross-server harassment are bannable.",
    "Use the correct channels to report issues — never take admin into your own hands.",
    "One character slot per citizen unless approved by staff.",
  ]},
];

export const PENAL_CODE = [
  { code: "PC-101", charge: "Trespassing", cls: "Infraction", fine: "$15", time: "—" },
  { code: "PC-118", charge: "Public Intoxication", cls: "Infraction", fine: "$25", time: "—" },
  { code: "PC-204", charge: "Petty Theft", cls: "Misdemeanor", fine: "$75", time: "5 min" },
  { code: "PC-231", charge: "Assault", cls: "Misdemeanor", fine: "$150", time: "10 min" },
  { code: "PC-245", charge: "Brandishing a Firearm", cls: "Misdemeanor", fine: "$200", time: "10 min" },
  { code: "PC-312", charge: "Grand Larceny", cls: "Felony", fine: "$500", time: "25 min" },
  { code: "PC-330", charge: "Horse Rustling", cls: "Felony", fine: "$450", time: "20 min" },
  { code: "PC-401", charge: "Armed Robbery", cls: "Felony", fine: "$1,200", time: "45 min" },
  { code: "PC-455", charge: "Kidnapping", cls: "Felony", fine: "$1,500", time: "60 min" },
  { code: "PC-501", charge: "Manslaughter", cls: "Felony", fine: "$2,000", time: "90 min" },
  { code: "PC-510", charge: "Murder", cls: "Capital", fine: "$5,000", time: "Life / Hanging" },
  { code: "PC-540", charge: "Bank Heist", cls: "Capital", fine: "$7,500", time: "Life" },
];

export const JOBS = [
  {
    slug: "sheriff", title: "Sheriff's Department", tag: "Law", img: 0,
    body: "Uphold the peace, patrol the roads, and answer the call when trouble rides into town.",
    intro: "The badge is heavy, and it should be. As a deputy of Aurora Springs you are the thin line between order and the lawless frontier. Every arrest tells a story, every patrol writes another page.",
    duties: ["Patrol the town and outlying roads", "Respond to robberies, shootouts and disputes", "Process arrests and enforce the Penal Code", "Protect stagecoaches, banks and citizens"],
    howto: "Speak to the Sheriff at the department in town to begin your application, then complete a ride-along with a senior deputy.",
    pay: "$45 – $180 / shift + arrest bonuses", req: "Clean record · Whitelisted · Voice roleplay",
  },
  {
    slug: "rancher", title: "Rancher", tag: "Trade", img: 1,
    body: "Break horses, herd cattle, and supply the town with meat and leather. Honest, hard work.",
    intro: "There is no wealth on the frontier without the land. Ranchers keep Aurora Springs fed, mounted and clothed — a living built on sweat, sunrise and stubborn cattle.",
    duties: ["Herd and drive cattle to market", "Break and sell horses", "Harvest and deliver goods", "Defend the herd from rustlers and wolves"],
    howto: "Head to The Ridge Ranch and speak with the foreman. No experience needed — just grit.",
    pay: "$30 – $120 / haul", req: "Open to all citizens",
  },
  {
    slug: "gunsmith", title: "Gunsmith", tag: "Craft", img: 2,
    body: "Forge, repair and customise the iron that keeps Aurora Springs standing.",
    intro: "Every legend needs a maker. Gunsmiths craft, repair and personalise the weapons that decide who walks away from the dust.",
    duties: ["Craft weapons and ammunition", "Repair and modify firearms", "Manage inventory and supply chains", "Serve law and outlaw alike — discreetly"],
    howto: "Apprentice under Crane & Sons Gunsmith. A steady hand and a good reputation open the door.",
    pay: "$40 – $200 / commission", req: "Craft-focused · Trusted",
  },
  {
    slug: "physician", title: "Physician", tag: "Medical", img: 0,
    body: "Patch up bullet wounds and fevers alike. The frontier is unforgiving without you.",
    intro: "When the guns fall silent, the doctor's work begins. Physicians are the most trusted souls in town — because everyone, sooner or later, needs one.",
    duties: ["Treat wounds, illness and overdoses", "Run the surgery and field response", "Stock and mix medicines", "Declare and document the dead"],
    howto: "Report to Doc Hart's Surgery for medical training and certification.",
    pay: "$50 – $160 / shift", req: "Mature RP · Patience",
  },
  {
    slug: "bounty-hunter", title: "Bounty Hunter", tag: "Outlaw", img: 1,
    body: "Track the wanted, dead or alive. High risk, higher reward for those with a keen eye.",
    intro: "Some men run. You are the reason they can't run far enough. Bounty hunting is the frontier's freest and most dangerous trade.",
    duties: ["Accept posted bounties", "Track and capture (or kill) targets", "Deliver the wanted to the law", "Survive the ones who fight back"],
    howto: "Collect your first warrant from the board outside the Sheriff's Office. Cunning over paperwork.",
    pay: "$100 – $1,200 / bounty", req: "High risk · Combat-ready",
  },
  {
    slug: "bartender", title: "Bartender", tag: "Service", img: 2,
    body: "Pour the whiskey, hear the secrets, run the finest saloon this side of the ridge.",
    intro: "The saloon is the beating heart of Aurora Springs. Behind the bar you'll hear every rumour, broker every deal, and pour the drink that starts (or ends) a feud.",
    duties: ["Serve drinks and run the saloon", "Host games, music and events", "Keep the peace — or profit from the chaos", "Gather and trade information"],
    howto: "Ask for work at The Aurora Saloon. Charisma is your résumé.",
    pay: "$25 – $110 / shift + tips", req: "Social RP · Reliable",
  },
];

export const STAFF = [
  { name: "Elias Crane", role: "Server Owner", face: 0 },
  { name: "Marlowe Vance", role: "Head Admin", face: 2 },
  { name: "Della Hart", role: "Community Manager", face: 1 },
  { name: "Silas Boon", role: "Lead Developer", face: 3 },
  { name: "Ruth Calloway", role: "Senior Moderator", face: 1 },
  { name: "Jonah Pike", role: "Support Lead", face: 0 },
];

export const STREAMERS = [
  { name: "stumbles7", twitch: "stumbles7", platform: "Twitch", live: false, face: 0, viewers: 0 },
  { name: "DustyDrifter", platform: "Twitch", live: true, face: 0, viewers: 214 },
  { name: "AuroraAnnie", platform: "Twitch", live: true, face: 1, viewers: 98 },
  { name: "SixGunSam", platform: "YouTube", live: false, face: 2, viewers: 0 },
  { name: "RidgeRunner", platform: "Kick", live: false, face: 3, viewers: 0 },
  { name: "MidnightMabel", platform: "Twitch", live: true, face: 1, viewers: 341 },
  { name: "OldTomKettle", platform: "YouTube", live: false, face: 0, viewers: 0 },
];

export const BUSINESSES = [
  { name: "The Aurora Saloon", type: "Saloon", x: 32, y: 44, body: "Whiskey, cards and live music every night." },
  { name: "Crane & Sons Gunsmith", type: "Gunsmith", x: 58, y: 38, body: "Custom irons and ammunition." },
  { name: "Springs General Store", type: "Retail", x: 46, y: 60, body: "Provisions, tools and everything between." },
  { name: "The Ridge Ranch", type: "Ranch", x: 74, y: 70, body: "Horses broken and cattle sold." },
  { name: "Doc Hart's Surgery", type: "Medical", x: 24, y: 66, body: "The only doctor for fifty miles." },
  { name: "Sheriff's Office", type: "Law", x: 40, y: 30, body: "Justice, jail and the long arm of the law." },
  { name: "Wells Fargo Bank", type: "Bank", x: 62, y: 54, body: "Keep your gold safe — if you can." },
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/guide", label: "Guide" },
  { to: "/rules", label: "Rules" },
  { to: "/penal-code", label: "Penal Code" },
  { to: "/jobs", label: "Jobs" },
  { to: "/businesses", label: "Businesses" },
  { to: "/gallery", label: "Gallery" },
];

export const NAV_MORE = [
  { to: "/lore", label: "Lore" },
  { to: "/tribes", label: "Native Tribes" },
  { to: "/gangs", label: "Gangs" },
  { to: "/streamers", label: "Streamers" },
  { to: "/staff", label: "Staff" },
  { to: "/scene-helper", label: "Scene Helper" },
  { to: "/upload", label: "Upload" },
  { to: "/support", label: "Tech Support" },
];
